import { render, staticRenderFns } from "./menuLaboratorio.vue?vue&type=template&id=e194ad54&scoped=true"
import script from "./menuLaboratorio.vue?vue&type=script&lang=js"
export * from "./menuLaboratorio.vue?vue&type=script&lang=js"
import style0 from "./menuLaboratorio.vue?vue&type=style&index=0&id=e194ad54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e194ad54",
  null
  
)

export default component.exports